/* Augusto Clean — JS mínimo, sem dependências. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  /* ---------- helpers ---------- */
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
    style: 'currency', currency: currency || document.documentElement.dataset.currency || 'BRL'
  }).format(Number(cents) / 100);
  let toastEl;
  const toast = (message, link) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = message;
    if (link) { const a = document.createElement('a'); a.href = link.url; a.textContent = link.label + ' →'; toastEl.appendChild(a); }
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 4000);
  };

  /* ---------- menu mobile ---------- */
  const toggle = $('[data-menu-toggle]');
  const mobile = $('[data-mobile-menu]');
  if (toggle && mobile) {
    toggle.addEventListener('click', () => {
      const open = mobile.hidden;
      mobile.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('svg').outerHTML = open
        ? '<svg class="icon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
        : '<svg class="icon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !mobile.hidden) { toggle.click(); toggle.focus(); } });
  }
  /* fecha dropdowns do menu desktop ao clicar fora */
  document.addEventListener('click', (e) => {
    $$('[data-nav-group][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-nav-group][open]').forEach((d) => { const within = d.contains(document.activeElement); d.removeAttribute('open'); if (within) $('summary', d).focus(); });
  });

  /* abre dropdowns no hover no desktop */
  if (window.matchMedia('(hover: hover) and (min-width: 1051px)').matches) {
    $$('[data-nav-group]').forEach((d) => {
      let timeout;
      d.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        d.setAttribute('open', '');
      });
      d.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          d.removeAttribute('open');
        }, 150);
      });
    });
  }

  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || document.documentElement.dataset.routesRoot || '/';
  const route = (path) => routeRoot.replace(/\/?$/, '/') + path;
  const plainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const localURL = (value) => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin ? url.href : route(''); } catch (_) { return route(''); }
  };
  const productImage = (src, className) => {
    if (!src) return null;
    try {
      const url = new URL(src, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      const img = node('img', className);
      img.src = url.href; img.alt = ''; img.width = 80; img.height = 80; img.loading = 'lazy';
      return img;
    } catch (_) { return null; }
  };

  /* ---------- filtros e paginação: apenas a região do catálogo ---------- */
  const catalog = $('[data-catalog]');
  if (catalog && window.fetch) {
    const status = $('[data-catalog-status]');
    let controller;
    const navigate = async (target, push = true, scroll = false) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const request = controller;
      const url = new URL(target, location.href);
      url.searchParams.delete('section_id');
      const requestURL = new URL(url);
      requestURL.searchParams.set('section_id', catalog.dataset.sectionId);
      catalog.setAttribute('aria-busy', 'true');
      status.textContent = 'Atualizando produtos…';
      try {
        const response = await fetch(requestURL, { signal: request.signal });
        if (!response.ok) throw new Error('catalog');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = $('[data-catalog]', html);
        if (!replacement || request.signal.aborted) throw new Error('catalog');
        const focus = catalog.contains(document.activeElement) ? document.activeElement : null;
        const focusId = focus && focus.id;
        const mobileOpen = $('[data-facets]', catalog)?.classList.contains('is-open');
        const collapsed = $$('.facet:not([open])', catalog).map((d) => d.dataset.filterName);
        catalog.replaceChildren(...replacement.childNodes);
        $$('.facet', catalog).forEach((d) => { if (collapsed.includes(d.dataset.filterName)) d.open = false; });
        if (mobileOpen) {
          $('[data-facets]', catalog)?.classList.add('is-open');
          const button = $('[data-facets-toggle]', catalog);
          if (button) { button.setAttribute('aria-expanded', 'true'); button.textContent = button.dataset.hide; }
        }
        if (push && url.href !== location.href) history.pushState({ catalog: true }, '', url);
        status.textContent = $('[data-results-count]', catalog)?.textContent.trim() || 'Produtos atualizados.';
        if (focus) (document.getElementById(focusId) || catalog).focus({ preventScroll: true });
        if (scroll) catalog.scrollIntoView({ block: 'start', behavior: 'instant' });
      } catch (error) {
        if (request.signal.aborted) return;
        status.textContent = 'Não foi possível atualizar os produtos. ';
        const retry = node('a', '', 'Abrir os resultados'); retry.href = url.href; status.append(retry);
      } finally {
        if (request === controller) catalog.removeAttribute('aria-busy');
      }
    };
    const formURL = (form) => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      const facetsForm = form.matches('.facets-form') ? form : $('.facets-form', catalog);
      if (facetsForm) {
        [...url.searchParams.keys()].forEach((key) => { if (key.startsWith('filter.') || key === 'sort_by') url.searchParams.delete(key); });
        const data = new FormData(facetsForm);
        new Set(data.keys()).forEach((key) => url.searchParams.delete(key));
        for (const [key, value] of data) if (value !== '') url.searchParams.append(key, value);
      }
      if (form.matches('[data-sort-form]')) url.searchParams.set('sort_by', form.elements.sort_by.value);
      return url;
    };
    catalog.addEventListener('submit', (e) => {
      if (!e.target.matches('.facets-form, [data-sort-form]')) return;
      e.preventDefault(); navigate(formURL(e.target));
    });
    catalog.addEventListener('change', (e) => {
      const form = e.target.closest('.facets-form, [data-sort-form]');
      if (form && form.reportValidity()) navigate(formURL(form));
    });
    catalog.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-facets-toggle]');
      if (toggle) {
        const open = $('[data-facets]', catalog).classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open)); toggle.textContent = open ? toggle.dataset.hide : toggle.dataset.show;
        return;
      }
      const link = e.target.closest('.active-facets a, .facets-actions a, .pagination a');
      if (!link || !plainClick(e)) return;
      e.preventDefault(); navigate(link.href, true, !!link.closest('.pagination'));
    });
    window.addEventListener('popstate', () => navigate(location.href, false));
  }

  /* ---------- busca preditiva, desktop e mobile ---------- */
  $$('[data-predictive-search]').forEach((form) => {
    const input = $('[data-predictive-input]', form);
    const panel = $('[data-predictive-panel]', form);
    const list = $('[data-predictive-list]', form);
    const status = $('[data-predictive-status]', form);
    const all = $('[data-predictive-all]', form);
    let timer, controller, active = -1, version = 0;
    const close = () => {
      clearTimeout(timer); if (controller) controller.abort(); version++;
      panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1;
    };
    const search = () => {
      close();
      const query = input.value.trim();
      if (query.length < 2) return;
      const ticket = version;
      timer = setTimeout(async () => {
        controller = new AbortController();
        const request = controller;
        const url = new URL(route('search/suggest.json'), location.origin);
        url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '5');
        const resultsURL = new URL(form.action);
        resultsURL.searchParams.set('q', query); resultsURL.searchParams.set('type', 'product'); resultsURL.searchParams.set('options[prefix]', 'last');
        all.href = resultsURL.href;
        list.replaceChildren(); status.textContent = 'Buscando produtos…'; panel.hidden = false; input.setAttribute('aria-expanded', 'true');
        try {
          const response = await fetch(url, { signal: request.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('search');
          const products = (await response.json()).resources.results.products;
          if (ticket !== version || request.signal.aborted) return;
          if (!Array.isArray(products)) throw new Error('search');
          products.forEach((product, index) => {
            const li = node('li'); li.setAttribute('role', 'presentation');
            const link = node('a', 'predictive-item'); link.href = localURL(product.url); link.id = `${list.id}-${index}`;
            link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false'); link.tabIndex = -1;
            const img = productImage(product.featured_image?.url || product.image, 'predictive-image'); if (img) link.append(img);
            const text = node('span', 'predictive-copy');
            text.append(node('span', 'predictive-title', product.title), node('span', 'predictive-price', money(Math.round(Number(product.price) * 100))));
            link.append(text); li.append(link); list.append(li);
          });
          status.textContent = products.length ? `${products.length} sugestões de produtos` : 'Nenhum produto encontrado. Tente outro termo.';
        } catch (error) {
          if (ticket === version && !request.signal.aborted) status.textContent = 'Sugestões indisponíveis. Pressione Enter para buscar.';
        }
      }, 250);
    };
    input.addEventListener('input', (e) => { if (!e.isComposing) search(); });
    input.addEventListener('compositionend', search);
    input.addEventListener('focus', search);
    form.addEventListener('submit', close);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); if (!panel.hidden) e.stopPropagation(); close(); return; }
      const options = $$('[role="option"]', list);
      if (panel.hidden || !options.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); active = active < 0 ? (e.key === 'ArrowDown' ? 0 : options.length - 1) : (active + (e.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, i) => option.setAttribute('aria-selected', String(i === active)));
        input.setAttribute('aria-activedescendant', options[active].id); options[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); options[active].click(); }
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    form.addEventListener('focusout', (e) => { if (!form.contains(e.relatedTarget)) close(); });
  });

  /* ---------- gaveta: dialog nativo contém foco e torna o fundo inerte ---------- */
  const drawer = $('[data-cart-drawer]');
  let cartUpdating = false;
  const updateCount = (cart) => $$('[data-cart-count]').forEach((count) => {
    count.textContent = cart.item_count; count.hidden = cart.item_count === 0;
    count.closest('a')?.setAttribute('aria-label', `Carrinho: ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'itens'}`);
  });
  const cartDrawer = drawer && typeof drawer.showModal === 'function' && window.fetch ? (() => {
    const items = $('[data-drawer-items]', drawer), status = $('[data-drawer-status]', drawer);
    const checkout = $('[data-drawer-checkout]', drawer), retry = $('[data-cart-retry]', drawer);
    let cart, opener, loading, readController, closeTimer, changed = false;
    const busy = (value) => {
      loading = value; items.setAttribute('aria-busy', String(value));
      $$('[data-cart-change]', drawer).forEach((b) => b.disabled = value);
      checkout.disabled = value || !cart?.item_count;
    };
    const render = (data) => {
      if (!Array.isArray(data.items)) throw new Error('Resposta do carrinho inválida.');
      cart = data; updateCount(cart); items.replaceChildren();
      cart.items.forEach((item) => {
        const li = node('li', 'drawer-item');
        const imageLink = node('a', 'drawer-item-image'); imageLink.href = localURL(item.url); imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden', 'true');
        const img = productImage(item.image, ''); if (img) imageLink.append(img);
        const info = node('div', 'drawer-item-info');
        const title = node('a', 'drawer-item-title', item.product_title); title.href = localURL(item.url); info.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', 'muted', item.variant_title));
        for (const [key, value] of Object.entries(item.properties || {})) if (key[0] !== '_' && value) info.append(node('p', 'muted', `${key}: ${value}`));
        if (item.selling_plan_allocation) info.append(node('p', 'muted', item.selling_plan_allocation.selling_plan.name));
        const prices = node('p', 'drawer-item-price');
        if (item.original_line_price > item.final_line_price) prices.append(node('s', 'muted', money(item.original_line_price, cart.currency)));
        prices.append(node('span', '', money(item.final_line_price, cart.currency))); info.append(prices);
        const controls = node('div', 'drawer-item-controls'), qty = node('div', 'qty');
        const control = (text, quantity, label, action) => {
          const button = node('button', '', text); button.type = 'button';
          button.dataset.cartChange = item.key; button.dataset.quantity = quantity; button.dataset.action = action;
          button.setAttribute('aria-label', `${label}: ${item.product_title}`); return button;
        };
        qty.append(control('−', item.quantity - 1, 'Diminuir quantidade', 'minus'), node('span', 'drawer-quantity', item.quantity), control('+', item.quantity + 1, 'Aumentar quantidade', 'plus'));
        controls.append(qty, control('Remover', 0, 'Remover', 'remove')); info.append(controls); li.append(imageLink, info); items.append(li);
      });
      $('[data-drawer-count]', drawer).textContent = `(${cart.item_count})`;
      $('[data-drawer-subtotal]', drawer).textContent = money(cart.total_price, cart.currency);
      $('[data-drawer-empty]', drawer).hidden = cart.item_count > 0;
      retry.hidden = true;
    };
    const refresh = async () => {
      if (readController) readController.abort();
      readController = new AbortController(); const request = readController;
      busy(true); status.textContent = 'Carregando carrinho…'; retry.hidden = true;
      try {
        const response = await fetch(route('cart.js'), { signal: request.signal, headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('cart');
        const data = await response.json(); if (request.signal.aborted) return;
        render(data); status.textContent = ''; busy(false);
      } catch (error) {
        if (request.signal.aborted) return;
        status.textContent = 'Não foi possível carregar o carrinho. Tente novamente ou abra o carrinho completo.'; retry.hidden = false;
        // Conteúdo anterior não deve permitir compra/alteração com estado desconhecido.
        busy(true);
      }
    };
    const open = (trigger) => {
      clearTimeout(closeTimer);
      if (!drawer.open) {
        opener = trigger || document.activeElement; drawer.showModal(); document.documentElement.classList.add('cart-is-open');
        requestAnimationFrame(() => drawer.classList.add('is-open'));
      }
      if (!cartUpdating) refresh();
      else { busy(true); status.textContent = 'Atualizando carrinho…'; }
    };
    const close = () => {
      drawer.classList.remove('is-open');
      closeTimer = setTimeout(() => drawer.close(), matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220);
    };
    drawer.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    drawer.addEventListener('close', () => {
      document.documentElement.classList.remove('cart-is-open'); opener?.focus({ preventScroll: true });
      if (changed && document.body.classList.contains('template-cart')) location.assign(route('cart'));
    });
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      if (e.target === drawer) { const r = drawer.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); return; }
      if (e.target.closest('[data-cart-retry]')) { if (!cartUpdating) refresh(); return; }
      const button = e.target.closest('[data-cart-change]');
      if (!button || loading || cartUpdating) return;
      const key = button.dataset.cartChange, action = button.dataset.action;
      cartUpdating = true; busy(true); status.textContent = 'Atualizando carrinho…';
      if (readController) readController.abort();
      try {
        const response = await fetch(route('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(button.dataset.quantity) }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Não foi possível alterar a quantidade.');
        render(data); changed = true; busy(false); status.textContent = 'Carrinho atualizado.';
      } catch (error) {
        // Uma falha de rede pode ocorrer após a alteração. Reconciliar sem reenviar POST.
        await refresh(); status.textContent = `${error.message || 'Não foi possível atualizar.'} Confira as quantidades antes de tentar novamente.`;
      } finally {
        cartUpdating = false;
        if (drawer.open) ($$('[data-cart-change]', drawer).find((b) => b.dataset.cartChange === key && b.dataset.action === action) || $('[data-cart-close]', drawer)).focus({ preventScroll: true });
      }
    });
    $$('[data-cart-open]').forEach((link) => {
      link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', drawer.id);
      link.addEventListener('click', (e) => { if (plainClick(e)) { e.preventDefault(); open(link); } });
    });
    const reconcile = async (message) => { await refresh(); status.textContent = message; };
    return { open, refresh, reconcile };
  })() : null;

  /* ---------- produto ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('[data-variant-id]', root);
    idInput.disabled = false;
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare]', root);
    const addBtn = $('[data-add]', root);
    const buyBtn = $('[data-buy-now]', root);
    const waBtn = $('[data-wa-buy]', root);
    const form = $('[data-product-form]', root);
    const optionGroups = $$('[data-option-index]', root);
    const gallery = $('[data-gallery]', root);
    let adding = false;
    const labels = { add: addBtn && addBtn.dataset.labelAdd, sold: addBtn && addBtn.dataset.labelSold, unavailable: addBtn && addBtn.dataset.labelUnavailable };

    const selected = () => optionGroups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    const findVariant = (opts) => (optionGroups.length ? variants.find((v) => v.options.every((o, i) => o === opts[i])) : variants[0]);

    const markAvailability = () => {
      const opts = selected();
      optionGroups.forEach((g, gi) => {
        $$('input', g).forEach((input) => {
          // Disponibilidade por prefixo evita prender opções válidas de outra combinação.
          const available = variants.some((v) => v.available && v.options[gi] === input.value && v.options.slice(0, gi).every((o, i) => o === opts[i]));
          input.disabled = !available;
          input.nextElementSibling.classList.toggle('is-unavailable', !available);
          input.setAttribute('aria-label', `${input.value}${available ? '' : ' — indisponível'}`);
        });
      });
    };

    const showMedia = (mediaId) => {
      if (!gallery || !mediaId) return;
      const target = $(`.gallery-item[data-media-id="${mediaId}"]`, gallery);
      if (!target) return;
      $$('.gallery-item', gallery).forEach((el) => el.classList.toggle('is-active', el === target));
      $$('.gallery-thumb', gallery).forEach((t) => t.setAttribute('aria-current', String(t.dataset.mediaId === String(mediaId))));
      $$('video', gallery).forEach((vid) => { if (!target.contains(vid)) vid.pause(); });
    };

    const priceBox = priceEl && priceEl.closest('.price');
    const update = (initial) => {
      const keepFrom = initial === true && priceBox && priceBox.hasAttribute('data-price-from');
      const v = findVariant(selected());
      markAvailability();
      optionGroups.forEach((g) => { const label = $('legend span', g); const checked = $('input:checked', g); if (label && checked) label.textContent = checked.value; });
      if (!v) {
        idInput.value = '';
        if (waBtn) { waBtn.setAttribute('aria-disabled', 'true'); waBtn.setAttribute('tabindex', '-1'); }
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = labels.unavailable; }
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      if (!keepFrom && priceBox && priceBox.hasAttribute('data-price-from')) { priceBox.removeAttribute('data-price-from'); const fromLabel = $('[data-price-from-label]', priceBox); if (fromLabel) fromLabel.remove(); }
      if (priceEl && !keepFrom) priceEl.textContent = money(v.price);
      if (compareEl && !keepFrom) { const onSale = v.compare_at_price && v.compare_at_price > v.price; compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(v.compare_at_price); priceEl && priceEl.closest('.price') && priceEl.closest('.price').classList.toggle('price--sale', !!onSale); }
      if (addBtn) { addBtn.disabled = adding || !v.available; addBtn.textContent = adding ? '…' : (v.available ? labels.add : labels.sold); }
      if (buyBtn) buyBtn.disabled = adding || !v.available;
      if (waBtn) { waBtn.setAttribute('aria-disabled', String(!v.available)); if (v.available) waBtn.removeAttribute('tabindex'); else waBtn.setAttribute('tabindex', '-1'); const u = new URL(waBtn.href); const base = waBtn.dataset.message || ''; u.searchParams.set('text', base.replace('{{variant}}', v.title === 'Default Title' ? '' : ` (${v.title})`) + ` — ${money(v.price)}`); waBtn.href = u.toString(); }
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      if (!keepFrom) { const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState(window.history.state, '', url); }
    };

    if (waBtn) waBtn.addEventListener('click', (e) => { if (waBtn.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
    optionGroups.forEach((g, index) => g.addEventListener('change', () => {
      const opts = selected();
      const exact = findVariant(opts);
      if (!exact || !exact.available) {
        const next = variants.find((v) => v.available && v.options.slice(0, index + 1).every((o, i) => o === opts[i]));
        if (next) optionGroups.forEach((group, i) => $$('input', group).forEach((input) => input.checked = input.value === next.options[i]));
      }
      update();
    }));

    if (gallery) {
      $$('.gallery-thumb', gallery).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));
      /* pausa vídeos ao trocar de item */
      gallery.addEventListener('click', () => $$('video', gallery).forEach((vid) => { if (!vid.closest('.is-active')) vid.pause(); }));
    }

    /* quantidade */
    const qty = $('[data-qty]', root);
    if (qty) {
      const input = $('input', qty);
      $$('button', qty).forEach((b) => b.addEventListener('click', () => {
        const step = Number(b.dataset.step);
        input.value = Math.max(1, (Number(input.value) || 1) + step);
      }));
    }

    /* add to cart via AJAX, com fallback nativo */
    if (form && addBtn && window.fetch) {
      form.addEventListener('submit', async (e) => {
        const chosen = findVariant(selected());
        if (adding || cartUpdating || !chosen || !chosen.available) { e.preventDefault(); return; }
        if (e.submitter && e.submitter.hasAttribute('data-buy-now')) return; /* checkout direto usa POST nativo */
        e.preventDefault();
        adding = true; cartUpdating = true; addBtn.disabled = true; addBtn.textContent = '…';
        if (buyBtn) buyBtn.disabled = true;
        let added = false;
        try {
          const body = new FormData(form); body.delete('checkout');
          const res = await fetch(route('cart/add.js'), { method: 'POST', body, headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error((await res.json()).description || 'erro');
          added = true;
          cartUpdating = false;
          if (cartDrawer) cartDrawer.open(addBtn);
          else {
            const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!response.ok) throw new Error('cart');
            updateCount(await response.json());
            toast(addBtn.dataset.labelAdded, { url: addBtn.dataset.cartUrl, label: addBtn.dataset.labelViewCart });
          }
        } catch (err) {
          if (added) toast(addBtn.dataset.labelAdded, { url: addBtn.dataset.cartUrl, label: addBtn.dataset.labelViewCart });
          else {
            const message = err instanceof TypeError ? 'Não foi possível confirmar. Confira o carrinho antes de tentar novamente.' : (err.message || 'Não foi possível adicionar.');
            if (cartDrawer && drawer.open) await cartDrawer.reconcile(message);
            else toast(message, { url: addBtn.dataset.cartUrl, label: addBtn.dataset.labelViewCart });
          }
        } finally { adding = false; cartUpdating = false; update(); }
      });
    }
    update(true);
  });

  /* Mantém o país já salvo ao editar um endereço. */
  $$('select[name="address[country]"][data-default]').forEach((select) => {
    const saved = select.dataset.default;
    const option = Array.from(select.options).find((o) => o.value === saved || o.textContent === saved);
    if (option) option.selected = true;
  });

  /* ---------- carrinho ---------- */
  $$('[data-cart-line]').forEach((line) => {
    const input = $('input[name^="updates"]', line);
    if (!input) return;
    $$('[data-qty] button', line).forEach((b) => b.addEventListener('click', () => {
      input.value = Math.max(0, (Number(input.value) || 0) + Number(b.dataset.step));
      input.form.submit();
    }));
    input.addEventListener('change', () => input.form.submit());
  });

  /* ---------- preview de vídeo no hover dos cards de produto ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let activeCard = null;

    const startPreview = (card) => {
      const video = $('video.product-card__video', card);
      if (!video) return;
      if (!video.src && video.dataset.src) video.src = video.dataset.src;

      const showIfStillActive = () => {
        if (activeCard === card) card.classList.add('is-video-playing');
      };

      if (video.readyState >= 2) {
        showIfStillActive();
      } else {
        video.addEventListener('loadeddata', showIfStillActive, { once: true });
      }

      const promise = video.play();
      if (promise !== undefined) {
        promise.catch(() => {});
      }
    };

    const stopPreview = (card) => {
      card.classList.remove('is-video-playing');
      const video = $('video.product-card__video', card);
      if (!video) return;
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_) {}
    };

    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('.product-card');
      if (!card || card === activeCard) return;
      if (card.contains(e.relatedTarget)) return;

      if (activeCard) stopPreview(activeCard);
      activeCard = card;
      startPreview(card);
    });

    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('.product-card');
      if (!card) return;
      if (card.contains(e.relatedTarget)) return;

      if (card === activeCard) {
        activeCard = null;
        stopPreview(card);
      }
    });

    window.addEventListener('blur', () => {
      if (activeCard) {
        stopPreview(activeCard);
        activeCard = null;
      }
    });
  }
})();
